import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter, useHistory } from 'react-router-dom'
/* Actions */
import { resetStore } from 'redux/actions/themeActions'
/* Styles */
import styled, { withTheme } from 'styled-components'
import LogoB from '../asset/img/Logo_B.png'
import Emitter from '../utils/Emitter'
import {
  Grid,
  AppBar as MuiAppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Fade,
  makeStyles,
  Button,
  Typography,
  Backdrop,
  ListItem,
} from '@material-ui/core'
import { ExitToApp, AccountCircle as Power } from '@material-ui/icons'
import { FlagImage } from './FlagImage'
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { style } from '@material-ui/system'
import { userLocalStorage } from 'config/local_storage'

// eslint-disable-next-line no-unused-vars
const StyledButton = withStyles({
  root: {
    borderRadius: 100,
    height: 36,
    margin: '7px 15px',
  },
})(Button)
const theme = createMuiTheme()
const LogoTitle = styled.div`
  margin-left: 10px;
`
const LogoHeading = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #00447c;
`
const Brand = styled(ListItem)`
  font-size: ${props => props.theme.typography.h5.fontSize};
  font-weight: ${props => props.theme.typography.fontWeightMedium};

  font-family: ${props => props.theme.typography.fontFamily};
  min-height: 56px;

  padding-right: ${props => props.theme.spacing(6)}px;
  cursor: default;

  ${props => props.theme.breakpoints.up('sm')} {
    min-height: 64px;
  }
`
const LogoSubHeading = styled.span`
  font-size: 14px;
  color: #40b3e0;
  font-weght: 400;
`
const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
  box-shadow: ${props => props.theme.shadows[1]};
`

function setDirection(dir) {
  document.body.style.direction = dir
}
const useStyles = makeStyles(theme => ({
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginLeft: '1.2rem',
    width: '14.3rem',
  },

  icon: {
    margin: '0px 7px',
  },
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: 56,
    width: 400,
  },
  root: {
    '&:hover': {
      borderRadius: 0,
    },
    borderRadius: 0,
  },
  userName: {
    color: '#464A53',
    fontFamily: 'Nunito',
    fontSize: '14px',
    fontWeight: '700',
  },
}))
const DropdownItem = styled.div`
  margin: 5px;
`

const languages = [
  { code: 'EN', label: 'United States', lang: 'English', phone: '1' },
  { code: 'HE', label: 'Israel', lang: 'Hebrew', phone: '972' },
  { code: 'ES', label: 'Spain', lang: 'Spanish', phone: '34' },
  { code: 'RU', label: 'Russian', lang: 'Russian', phone: '7' },
]

function UserMenu({ user, ...props }) {
  const [anchorMenu, setAnchorMenu] = React.useState(null)
  const [open, setOpen] = React.useState(false)

  const classes = useStyles()
  const { t } = useTranslation('common')

  const toggleMenu = event => setAnchorMenu(event.currentTarget)

  const closeMenu = () => setAnchorMenu(null)

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <IconButton
          aria-haspopup="true"
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          onClick={toggleMenu}
          color="inherit"
          className={classes.root}
          disableRipple={true}>
          <Power className={classes.icon} />
          <Typography component={'span'} variant="subtitle1" className={classes.userName}>
            {user ? user.firstName + ' ' + user.lastName : null}
          </Typography>
        </IconButton>

        <Menu
          id="menu-appbar"
          anchorEl={anchorMenu}
          open={Boolean(anchorMenu)}
          onClose={closeMenu}
          getContentAnchorEl={null}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'center', vertical: 'top' }}
          className={classes.menu}>
          <MenuItem onClick={closeMenu}>
            <IconButton
              aria-haspopup="true"
              className={classes.root}
              aria-owns={anchorMenu ? 'menu-appbar' : undefined}
              color="default"
              disableRipple={true}
              onClick={() => {
                closeMenu()
                setOpen(true)
              }}>
              <ExitToApp />{' '}
              <Typography component={'span'} variant="subtitle1" classes={style.icon} style={{ fontSize: '20px' }}>
                {t('common.logout')}
              </Typography>
            </IconButton>
          </MenuItem>
        </Menu>

        <Modal
          open={open}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}>
          <Fade in={open}>
            <div className={classes.paper}>
              <p id="transition-modal-description">{t('common.surelogout')}</p>
              <div className={classes.buttons}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setOpen(false)
                    Emitter.emit('lOGGED_OUT', true)
                    props.signout()
                  }}>
                  {t('common.yes') + ', ' + t('common.logout')}
                </Button>
                <Button variant="contained" onClick={() => setOpen(false)} color="primary">
                  {t('common.no')}
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
      </ThemeProvider>
    </React.Fragment>
  )
}

function LanguageMenu(props) {
  const language = new URLSearchParams(window.location.search).get('lang')

  const history = useHistory()
  const [anchorMenu, setAnchorMenu] = React.useState(null)
  const userLangugage = language || userLocalStorage.get('lang')

  const [lang, setLang] = React.useState({
    code: userLangugage ? userLangugage.toLocaleUpperCase() : 'EN',
    lang: userLangugage ? languages.find(language => language.code.toLowerCase() === userLangugage).lang : 'English',
  })

  const { i18n } = useTranslation('common')
  const toggleMenu = event => setAnchorMenu(event.currentTarget)

  React.useEffect(
    () => languages.map(value => value.code && value.code.toLowerCase() === language && setLang(value)),
    [],
  )

  const closeMenu = (lang, code) => {
    setAnchorMenu(null)
    setLang({ code, lang })
    setDirection(code === 'HE' ? 'rtl' : 'ltr')
    i18n.changeLanguage(code.toLowerCase())
    if (code.toLocaleLowerCase() === 'us') {
      history.push(`${props?.location?.pathname}?lang=en`)
    } else {
      history.push(`${props?.location?.pathname}?lang=${code.toLowerCase()}`)
    }
    userLocalStorage.set('lang', code.toLowerCase())
  }

  return (
    <React.Fragment>
      {lang.code && (
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          className="lang-label">
          <FlagImage countryCode={lang.code} />
        </IconButton>
      )}
      <Menu
        id="menu-appbar"
        getContentAnchorEl={null}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={e => setAnchorMenu(null)}>
        {languages &&
          languages.map((item, index) => (
            <MenuItem key={`${item}-${index}`} onClick={e => closeMenu(item.lang, item.code)}>
              <DropdownItem>
                <FlagImage countryCode={item.code} />
              </DropdownItem>
              {item.lang}
            </MenuItem>
          ))}
      </Menu>
    </React.Fragment>
  )
}

const Header = withRouter(({ onDrawerToggle, location, user, history, lang, ...props }) => (
  <React.Fragment>
    <AppBar position="sticky" elevation={0} color="default">
      <Toolbar>
        <Grid container alignItems="center" justify="space-between" wrap="nowrap">
          <Grid onClick={() => history.push(`/register/${location?.search}`)} item>
            <Brand>
              <img src={LogoB} alt="logo" height="100%" />
              <LogoTitle>
                <LogoHeading>BNEI BARUCH</LogoHeading>
                <br />
                <LogoSubHeading>VIRTUAL HOME</LogoSubHeading>
              </LogoTitle>
            </Brand>
          </Grid>
          <Grid item>
            <Grid container alignItems="center" direction="row" wrap="nowrap">
              <Grid item>
                <LanguageMenu location={location} lang={lang} />
              </Grid>
              <Grid item>
                <UserMenu user={user} signout={props.resetStore} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  </React.Fragment>
))

Header.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  onDrawerToggle: PropTypes.any,
  user: PropTypes.any,
}
LanguageMenu.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.any,
    search: PropTypes.any,
  }),
}

UserMenu.propTypes = {
  signout: PropTypes.func,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.any,
  }),
}
const mapStateToProps = state => ({ user: state.registrationReducer.user })

export default connect(mapStateToProps, { resetStore })(withTheme(Header))
